module.exports = __webpack_public_path__ + "assets/tissus3D-141abba44ce1414e89f7a4efa204b216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/tissus3D.jpg
// module id = 526
// module chunks = 1